import { useContext, useCallback, useState } from "react";
import { MainContext } from "../../contexts/main";
import { getText } from '@educaplay/app-core/language';
import { BlockPlan } from "./BlockPlan";
import { scrollTo } from "../../helpers/functions";
import config from "../../resources/config.json";
import { SVG_licenses } from "../elements/SVG";
import { InputUpDown } from "../inputs/InputUpDown";
import { getURL } from "../../helpers/urls";

const TYPE_PLANS = {
    INDIVIDUAL: 'individual',
    TEAM: 'team'
}
const DEFAULT_TEAMPLAN_LICENSES = 10;
const DEFAULT_INDIVIDUAL_LICENSES = 1;

export const BlockPlans = () => {
  const { environment, mainReducer, appReducer } = useContext(MainContext);
  const currentNumLicenses = mainReducer.state.selectedLicense.licenses;  
  const [typePlanSelected, setTypePlanSelected] = useState(currentNumLicenses > 1 ? TYPE_PLANS.TEAM : TYPE_PLANS.INDIVIDUAL);

  const handleChangeLicenses = useCallback(
    (value) => {
      setTypePlanSelected(value > 1 ? TYPE_PLANS.TEAM : TYPE_PLANS.INDIVIDUAL);
       if(value > 1 && mainReducer.state.selectedLicense.periodicity === 'monthly'){
          mainReducer.dispatch({
             type: 'changePeriodicity',
             payload: 'yearly'
         });
       }
      const action = {
        type: "changeLicenses",
        payload: value,
      };
      mainReducer.dispatch(action);
    },
    [mainReducer],
  );

  const handleOpenLicense = () => {
    appReducer.dispatch({
      type: "openModal",
      payload: {
        id: "license",
      },
    });
  };

   const handleTeamPlanClick = (planId) => {
    const url = getURL(environment, 'teamPlan') + '?id=' + planId + '&numplans=' + currentNumLicenses;
    window.open(url, '_blank').focus();
  }

  const handleSelectIndividualPlan = () => {
    if(typePlanSelected === TYPE_PLANS.INDIVIDUAL) return;
    setTypePlanSelected(TYPE_PLANS.INDIVIDUAL); 
    const action = {type: "changeLicenses", payload:DEFAULT_INDIVIDUAL_LICENSES};
    mainReducer.dispatch(action);
  }

  const handleSelectTeamPlan = () => {
    if(typePlanSelected === TYPE_PLANS.TEAM) return;  
    setTypePlanSelected(TYPE_PLANS.TEAM);
    const action = {type: "changeLicenses", payload:DEFAULT_TEAMPLAN_LICENSES};
    if(mainReducer.state.selectedLicense.periodicity === 'monthly'){
         mainReducer.dispatch({
            type: 'changePeriodicity',
            payload: 'yearly'
        });
    }
    mainReducer.dispatch(action);
  }

  return (
    <>
      <section className="e__plns__lst__main">
        <div className="e__switch">
          <div className="e__switch__wrapper">
              <button className={`e__switch__btn px-sm  ${typePlanSelected === TYPE_PLANS.INDIVIDUAL ? 'active' : ''}`} onClick={handleSelectIndividualPlan}>{getText('individual_plan')}</button>
          </div>
          <div className="e__switch__wrapper">
              <button className={`e__switch__btn px-sm  ${typePlanSelected === TYPE_PLANS.TEAM ? 'active' : ''}`} onClick={handleSelectTeamPlan}>{getText('team_plans')}</button>
          </div>
        </div>
        <InputUpDown
          field="licenses"
          value={currentNumLicenses}
          handleSave={handleChangeLicenses}
          min={1}
          max={999}
          icon={
            <SVG_licenses />
          }
        />
        
        <div
          className={`e__plns__lst__wpr${mainReducer.state.user === false ? " e__plns__lst__wpr--basic" : ""}`}
        >
          {Object.keys(config.plans).map((index) => (
            <BlockPlan
              key={index}
              id={index}
              teamPlanClick={() => handleTeamPlanClick(index)}
              disablePeriodicity={currentNumLicenses >= 2}
            />
          ))}
        </div>
        <div className="e__txt__lgl">
          {getText("licencias_y_condiciones_disclaimer")}{" "}
          <button onClick={handleOpenLicense} className="e__lnk">
            {getText("licencias_y_condiciones")}
          </button>
        </div>
        <div className="e__plns__lst__main__nv">
          <button onClick={() => scrollTo("sectionPriceTable")}>
            {getText("comparar_title")}
          </button>
          <button onClick={() => scrollTo("sectionFAQ")}>
            {getText("faq")}
          </button>
        </div>
      </section>
    </>
  );
};
